import { RuntimeExamResultScreen } from '@/features/unified-learning/runtime/screens/RuntimeExamResultScreen';

export default function LearnExamResultRoute() {
  return <RuntimeExamResultScreen runtimeBase="/learn/path" />;
}
